import qs from 'querystring'
 
import _ from 'underscore'
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import { toLogin } from '../util/function'

const setSession = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.common.set-cache',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve()
    }, (e) => {
      reject(e)
    })
  })
}
export default {
  setSession,
}
